import BackupIcon from '@material-ui/icons/Backup';
import ResourceCreate from './ResourceCreate';
import ResourceEdit from './ResourceEdit';
import ResourceList from './ResourceList';
import ResourceShow from './ResourceShow';

const pages = {
    list: ResourceList,
    create: ResourceCreate,
    edit: ResourceEdit,
    show: ResourceShow,
    icon: BackupIcon,
};

export default pages;